import { PagedSearch } from '../../../shared/model/paged-search.model';

export class ProfileViewRecentContactsSearch extends PagedSearch {
  public ProfileId: number;

  public constructor() {
    super();

    this.ProfileId = 0;
  }
}
